import { Anchor } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { Id } from '@feature/utils';

export interface PublisherLinkProps {
  publisherId: Id;
  title: string;
}

export function PublisherLink(props: PublisherLinkProps) {
  const { publisherId, title } = props;
  return (
    <Anchor
      fw="500"
      c="text"
      component={Link}
      to={`/publisher/${publisherId}`}
    >
      {title}
    </Anchor>
  );
}
